module.exports = __webpack_public_path__ + "static/castle2-41c70c0398ad0e3b550d6b028fce0e55.jpg";